<app-org-appbar></app-org-appbar><br />
<div kendoDialogContainer></div>
<div class="detection-controls row align-items-center g-0">
  <div class="col-4 d-flex align-items-center gap-2">
    <kendo-label
      class="me-1"
      text="Filter by tag"
      labelCssClass="k-form-label"
      [for]="detectionTagsRef"
    ></kendo-label>
    <kendo-multiselect
      style="width: 400px"
      #detectionTagsRef
      [(ngModel)]="selectedTags"
      [filterable]="true"
      [data]="availableTags()"
      textField="name"
      valueField="id"
      [valuePrimitive]="false"
      (valueChange)="filterDetetections()"
      (filterChange)="onTagFilterChange($event)"
    ></kendo-multiselect>
  </div>

  <div class="col-5 d-flex justify-content-center">
    @if (alertSyncControls().propagate_to_children || alertSyncControls().stop_parent_sync) {
    <div class="sync-settings">
      @if (alertSyncControls().propagate_to_children) {
      <span class="sync-setting">
        Alert Preferences Propagation:
        <strong>{{ propagateEnabled() ? 'Enabled' : 'Disabled' }}</strong>
      </span>
      }
      @if (alertSyncControls().stop_parent_sync) {
      <span class="sync-setting">
        Stop Parent Synchronization:
        <strong>{{ stopParentSyncEnabled() ? 'Enabled' : 'Disabled' }}</strong>
      </span>
      }
    </div>
    }
  </div>

  <div class="col-3 d-flex justify-content-end">
    <!-- Manual propagation: shown for a non-root org with children, independent
         of the propagate toggle state (it can trigger propagation itself). -->
    @if (alertSyncControls().propagate_to_children) {
    <button
      kendoButton
      themeColor="primary"
      [disabled]="isPropagating() || isLoading() || !organizationId()"
      (click)="onPropagateClick()"
    >
      @if (isPropagating()) {
      <span class="spinner-border spinner-border-sm me-2"></span>
      Propagating... } @else { Propagate to child organizations }
    </button>
    }
  </div>
</div>
<hr />
<div>
  <div
    class="k-card-list"
    (scroll)="onScroll($event)"
  >
    @for (detection of filteredDetections(); track detection.detectionId) {
      <div class="item-container">
        <kendo-card class="k-card-item">
          <kendo-card-header>
            <h5>{{ detection.title }}</h5>
          </kendo-card-header>
          <kendo-card-body>
            <p>{{ detection.description }}</p>
            <p>
              @for (tag of detection.tags; track tag.id) {
                <kendo-chip
                  size="small"
                  [label]="tag.name"
                  class="me-1 mb-1"
                ></kendo-chip>
              }
            </p>
          </kendo-card-body>
          <kendo-card-footer>
            <kendo-switch
              [checked]="detection.active"
              onLabel="Active"
              offLabel="Muted"
              (valueChange)="onToggleChange(detection, $event)"
              [disabled]="updatingDetectionId() === detection.detectionId"
            ></kendo-switch>
          </kendo-card-footer>
        </kendo-card>
      </div>
    }
  </div>
</div>
